<template>
  <ion-page style="max-width: 800px; margin:auto">

    <ion-content :fullscreen="true" ref="myContent" id="background">

      <div v-for="item in jsonContent" :key="item.id">

        <ion-item v-if="item.type!='video'" :class="[item.type, chat]"
                  :color="item.type == 'input_text' ? 'dark' : ''">
          <ion-label v-html="item.the_content"></ion-label>
        </ion-item>

        <ion-card v-if="item.type=='video'" color="dark">
          <iframe width="100%" :height='this.videoHeight' :src="item.video" frameborder="0" allowfullscreen=""></iframe>
        </ion-card>

      </div>

    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <ion-input v-on:keyup.enter="sendMessage()" v-model='inputBox' placeholder="Tu mensaje"></ion-input>
        <ion-buttons slot="end">
          <ion-button @click="sendMessage()" type="submit" fill="outline">
            Enviar
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>


  </ion-page>
</template>

<script>
import {IonContent, IonInput, IonPage, IonToolbar} from '@ionic/vue';
import {defineComponent} from 'vue';
import { onIonViewDidEnter} from '@ionic/vue';

export default defineComponent({
  name: 'Home',
  components: {
    IonContent,
    IonInput,
    IonPage,
    IonToolbar
  },
  setup() {
    onIonViewDidEnter(() => {
      // this.jsonResponses =
      // const myjson = require('../../public/assets/responses.json');
      // alert(myjson[0].the_content)
      // alert(this.jsonResponses[0].the_content);
    });
  },
  mounted() {
    this.videoHeight = window.innerHeight - 100;
  },
  methods: {

    getAnswerFromText: async function (message) {
      console.log(message)
      const foo = this.getAnswerFromLookUp(message);
      await new Promise(r => setTimeout(r, 1800));
      return new Promise((resolve) => resolve(foo));
    },

    getAnswerFromLookUp: function(message) {
      const elementToResponse = this.jsonResponses.find(element => element.id == message)
      return elementToResponse.the_content;
    },

    sendMessage: async function () {

      this.lastId++;
      this.jsonContent.push(
          {
            "id": this.lastId,
            "type": "input_text",
            "the_content": this.inputBox
          }
      );

      setTimeout(() => this.$refs.myContent.$el.scrollToBottom(), 60)

      const answerFromSystem = await this.getAnswerFromText(this.inputBox);

      this.lastId++;

      this.jsonContent.push(
          {
            "id": this.lastId,
            "type": "output_text",
            "the_content": answerFromSystem
          },
      );

      setTimeout(() => this.$refs.myContent.$el.scrollToBottom(), 60)

      this.inputBox = '';

      // const myContentRef = ref('myContent');
      // myContentRef.value.scr;
      // this.$refs.value.$el.scrollToBottom();
      // console.log(JSON.stringify(myContentRef))

    }
  },
  data() {
    return {
      videoHeight: 600,
      jsonResponses: require('../../public/assets/responses.json'),
      lastId: 8,
      chat: 'chat',
      inputBox: '',
      jsonContent: [
        {
          "id": "1",
          "type": "output_text",
          "the_content": "Hoy, mientras paseabas por la calle, te encontraste con un objeto en el suelo<br>" +
              "Parece un teléfono móvil, pero uno que no habías visto nunca antes<br> Al llegar a casa tratas de enchufarlo... <br> y...."
        },
        {
          "id": "2",
          "type": "video",
          "video": "https://www.youtube.com/embed/DADwYHr0BPA?modestbranding=1&autoplay=1&rel=0"
        },
        {
          "id": "3",
          "type": "output_text",
          "the_content": "Aquí tienes tu primera prueba<br>" +
              "¿Qué había además de ónice en la tierra?<br> (Génesis 2:12)<br>"
        },
      ]
    }
  }
});


</script>

<style>

ion-content {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
  --background: none;
  /*background: url("https://i.pinimg.com/originals/a0/cc/e6/a0cce6241499f86685145d9cb8b54bed.jpg")  no-repeat center center / cover;*/
  /*background-position: center center;*/
  /*background-repeat: no-repeat;*/
  /*background-size: cover;*/
  /*!*background-image: url("https://i.pinimg.com/236x/c8/c8/85/c8c88579b777021c295d49ca2b9d6751.jpg");*!*/
  /*!*background-image: url("https://i.pinimg.com/474x/8b/7a/26/8b7a26435ec37f85f901b87de07b3b4a.jpg");*!*/
  /*background-image: url("https://i.pinimg.com/originals/fb/94/a2/fb94a2c6ccee8a2f78217caf5e4d870e.png");*/
  /*--background: url("https://i.pinimg.com/originals/a0/cc/e6/a0cce6241499f86685145d9cb8b54bed.jpg") 100% 100% no-repeat;;*/
  /*background-image: url("https://i.pinimg.com/474x/a1/ad/4d/a1ad4d915b53823775d388d6d196ec6e.jpg");*/
  background-image: url("https://i.pinimg.com/originals/3d/dc/e4/3ddce4501efa0cae53c5f4934d286383.png");
  /*--background-size: contain;*/
}

body {
  background: url("https://i.pinimg.com/originals/a0/cc/e6/a0cce6241499f86685145d9cb8b54bed.jpg") no-repeat center/cover fixed !important;
}

.chat ion-label {
  white-space: normal !important;
}

ion-item.chat {
  border: 1px solid grey;
  border-radius: 15px;
  opacity: 0.8;
}

ion-item.chat.output_text {
  margin: 10px 10px 10px 60px;
}

ion-item.chat.input_text {
  margin: 10px 60px 10px 10px;
}

ion-card-content {
  padding: 0px !important;
}


</style>
